import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IRateEmitter } from 'src/app/libs/ui/components/sliders/interfaces/sliders.interface';
import { RadioButtonOptions } from 'src/app/libs/data-access/models/consts/radio-options.const';
import { RadioButtonOption } from 'src/app/libs/data-access/models/interfaces/radio-interface';
import { FlightsFilterTypeApiKeyEnum } from '../../../data-access/model/enums/flight-filter.enum';
import { IFilterMetadata } from '../../../data-access/model/interfaces/flight-filter.interface';

@Component({
  selector: 'tic-flights-filters-container',
  templateUrl: './flights-filters-container.component.html',
  styleUrls: ['./flights-filters-container.component.scss']
})

export class FlightsFiltersContainerComponent {
  @Input() filtersOptionsMetadata!: IFilterMetadata;
  @Input() expandAllFiltersAsDefault: boolean = true;
  @Output() onFilterSelected: any = new EventEmitter();
  flightsFilterTypeApiKeyEnum = FlightsFilterTypeApiKeyEnum;

  radioOptions: RadioButtonOption[] =RadioButtonOptions;
  selectedOption: number = this.radioOptions[1].value;

  onSelectionChange(value: number, filterType: FlightsFilterTypeApiKeyEnum): void {
    this.selectedOption = value;
    this.onFilterSelected.emit({ filterType, value });
  }

  onSliderRangeChange(event: IRateEmitter, filterType: FlightsFilterTypeApiKeyEnum): void {
    this.onFilterSelected.emit({ filterType, value: event });
  }
  
}
